/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use 'variables';
@use 'mixins';

html,
body {
  margin: 0;
  padding: 0;
  background-color: variables.$background-color-body;
}

.shadow-root {
  all: initial;
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
}

* {
  box-sizing: border-box;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.accent {
  color: variables.$text-color-primary;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  column-gap: variables.$gap-between-lists;
  &.two-row {
    > div {
      width: 50%;
      > div {
        @include mixins.use-available-space;
      }
    }
  }
}

.column {
  display: flex;
  flex-direction: column;
}

.full-width {
  @include mixins.use-available-space;
}

button.MuiButton-contained {
  color: variables.$color-white;
}
label.MuiFormControlLabel-root {
  display: flex;
  margin-right: 0;
}
span.MuiButtonBase-root.MuiRadio-root:hover,
span.MuiButtonBase-root.MuiCheckbox-root:hover,
label.MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementEnd:hover {
  background-color: variables.$background-color-hover;
  border-radius: 4px;
}

.symptoms-list {
  padding: 0 0 0 10px;
}

.small-spacer {
  height: 12px;
}

.MuiFormControl-root.MuiFormControl-fullWidth.MuiTextField-root,
.MuiInputBase-root.textfield-select-group-select {
  margin-top: 20px;
}
.no-margin-top.MuiFormControl-root.MuiFormControl-fullWidth.MuiTextField-root,
.no-margin-top .MuiFormControl-root.MuiFormControl-fullWidth.MuiTextField-root,
.no-margin-top .MuiInputBase-root.textfield-select-group-select,
p.no-margin-top.MuiTypography-root {
  margin-top: 0;
  height: fit-content;
}
.add-margin-top {
  margin-top: variables.$margin-large;
}
.add-margin-top-small {
  margin-top: variables.$padding-medium;
}

.add-margin-bottom {
  margin-bottom: variables.$margin-large;
}

.indented {
  padding-left: variables.$padding-large;
  margin-left: 10px;
  border-left: 2px solid variables.$color-corpuls-secondary-50;
}
.indented-checkbox-parent {
  padding-left: variables.$padding-large;
  margin-left: 20px;
  border-left: 2px solid variables.$color-corpuls-secondary-50;
}

//hide arrows
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}

button.cancel-button {
  color: variables.$text-color-secondary;
  border-color: variables.$text-color-secondary;
  &:hover {
    background-color: variables.$background-color-hover;
  }
}

.list-subheading {
  @include mixins.style-as-h2;
  margin-top: variables.$margin-medium;
  margin-bottom: variables.$margin-medium;
}

.prefilled {
  border-radius: 4px;
  background-color: variables.$color-system-blue-lightest;
}

.MuiDialogActions-root {
  padding: 0 24px 24px 0;
}

.legend.row {
  justify-content: flex-start;
  align-items: center;
  .indicator {
    width: 30px;
    height: 15px;
    background-color: variables.$color-system-blue-lightest;
    border: 1px solid rgba(0, 0, 0, 0.23); //mui input-border-color
    border-radius: 5px;
  }
}

button.ready-button {
  padding: 3px 15px 3px 3px;

  .MuiButton-startIcon {
    background-color: variables.$background-color-hover;
    width: variables.$footer-button-height;
    height: variables.$footer-button-height;
    padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: variables.$footer-button-height;
  }

  &.MuiButton-contained {
    background-color: variables.$color-corpuls-system-green-lightest;

    .MuiButton-startIcon {
      background-color: variables.$color-corpuls-system-green;
    }
  }
}

.as-table-typography {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: inherit;
  margin-top: 0;
  margin-bottom: 0;
}
